import { render } from "./MenuHidingBehavior.vue?vue&type=template&id=6268fbf4&ts=true"
import script from "./MenuHidingBehavior.vue?vue&type=script&lang=ts"
export * from "./MenuHidingBehavior.vue?vue&type=script&lang=ts"

import "./MenuHidingBehavior.vue?vue&type=style&index=0&id=6268fbf4&lang=css"

import exportComponent from "C:\\NEW DTC 2021\\ecpv\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__